import { Box, useMediaQuery } from '@mui/material';
import { RecordingList } from '@parsys/frontend_library';
import { useSelector, useDispatch } from 'react-redux';

import { updateTableContext } from 'FRONTEND/reducers/tableSlice';
import { selectTenantMapWithRights } from 'FRONTEND/reducers/userSlice';
import i18n from 'FRONTEND/utils/i18n';
import { RIGHTS } from 'FRONTEND/utils/rights';

const Recordings = ({ url, token }) => {
  const dispatch = useDispatch();
  const hasDownloadRights = useSelector(state => state.user.rights.includes(RIGHTS.RECORDINGS_LIST));
  const locale = useSelector(state => state.user.locale);
  const tenantMap = useSelector(state => selectTenantMapWithRights(state, [RIGHTS.RECORDINGS_LIST, RIGHTS.RECORDINGS_READ]));


  // Data persist management
  const location = window.location.pathname;
  const savedTenantList = useSelector(state => state.table.tableContext[location]?.tenantList);

  const handleTenantListChange = (list) => {
    dispatch(updateTableContext({ tableName: location, contextObject: { tenantList: list } }));
  };

  // STYLES
  const isSmallScreen = useMediaQuery('(max-width:900px)');

  // LOCALISATION
  const labelMap = {
    roomId: i18n._('Room ID'),
    startTime: i18n._('Start time'),
    endTime: i18n._('End time'),
    duration: i18n._('Duration'),
    download: i18n._('Download'),
    filter: i18n._('Filter'),
    startDate: i18n._('Start date'),
    endDate: i18n._('End date'),
    displayDetails: i18n._('Display details'),
    hideDetails: i18n._('Hide details'),
    tenantId: i18n._('Tenant'),
    stationAlias: i18n._('Station'),
    noResults: i18n._('No recordings found for the selected date range. Try a wider search.'),
    errorMessage: i18n._('An error occurred while fetching recordings. Please contact Parsys support.'),
  };

  if (!url || !token) {
    return <div>{i18n._('Invalid configuration')}</div>;
  }

  return (
    <Box sx={{ paddingX: isSmallScreen ? 1 : '10%' }}>
      <RecordingList
        recordingFilesServerUrl={url}
        recordingsFilesToken={token}
        hasDownloadRights={hasDownloadRights}
        labelMap={labelMap}
        tenantMap={tenantMap}
        initialTenantSearchList={savedTenantList}
        onTenantSearchListChange={handleTenantListChange}
        filterStyles={{
          marginY: 2,
          '& .MuiInputBase-root': {
            borderRadius: '50vh',
            height: 36,
          },
          '& .MuiButton-root': {
            borderRadius: '50vh',
            height: 36,
          },
        }}
        gridLocale={locale}
        tableStyles={{
          '& .MuiDataGrid-row .MuiButton-root:hover': {
            color: 'white', // Necessary because it seems PC theme is changing the color on hover
          },
        }}
      />
    </Box>
  );
};

export default Recordings;
